// TODO: #126830 We should be able to delete this component and replace with library equivalent once Offshore Reporting has been moved to reporting-V2 NX lib

import {
  Component,
  Output,
  EventEmitter,
  effect,
  signal,
  Signal,
  computed,
} from '@angular/core';
import { DatePicker } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule, MultiSelectChangeEvent } from 'primeng/multiselect';
import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';

export const beaufortOptionsData = [
  { name: '1', code: 1 },
  { name: '2', code: 2 },
  { name: '3', code: 3 },
  { name: '4', code: 4 },
  { name: '5', code: 5 },
  { name: '6', code: 6 },
  { name: '7', code: 7 },
  { name: '8', code: 8 },
  { name: '9', code: 9 },
  { name: '10', code: 10 },
  { name: '11', code: 11 },
  { name: '12', code: 12 },
];

const typeOptionsData = [
  { name: 'All Reports', code: '' },
  { name: 'Sea Reports', code: 'Sea' },
  { name: 'Port Reports', code: 'Port' },
  { name: 'Anchor/Drifting Reports', code: 'Anchor' },
  { name: 'Maneuvering Reports', code: 'Maneuvering' },
  { name: 'Arrival Reports', code: 'Arrival' },
  { name: 'Departure Reports', code: 'Departure' },
];

export interface Dropdown {
  name: string;
  code: string | number;
}

export interface FilterData {
  fromDate: Date | undefined;
  toDate: Date | undefined;
  beaufortSelected: Dropdown[];
  beaufortAllSelected: boolean;
  draught: number | undefined;
  typeSelected: Dropdown;
}

const DEFAULT_FILTER_DATA: FilterData = {
  fromDate: undefined,
  toDate: undefined,
  beaufortSelected: beaufortOptionsData,
  beaufortAllSelected: true,
  draught: undefined,
  typeSelected: { name: 'All Reports', code: '' },
};

@Component({
  selector: 're-report-filters',
  templateUrl: './report-filters.component.html',
  styleUrl: './report-filters.component.css',
  imports: [
    DatePicker,
    FormsModule,
    MultiSelectModule,
    InputTextModule,
    SelectModule,
    StyleClassModule,
    CheckboxModule,
    ButtonModule,
  ],
})
export class ReportFiltersComponent {
  @Output() filterValuesEvent = new EventEmitter<FilterData>();

  beaufortOptions: Dropdown[] = beaufortOptionsData;
  typeOptions: Dropdown[] = typeOptionsData;
  label: Signal<string> = computed(() => {
    if (this.filterData().beaufortAllSelected) return 'All';
    return this.filterData().beaufortSelected.length + ' Items Selected';
  });
  filterData = signal<FilterData>({ ...DEFAULT_FILTER_DATA });

  constructor() {
    effect(() => {
      this.filterValuesEvent.emit(this.filterData());
    });
  }

  updateBeaufortSelection(event: MultiSelectChangeEvent) {
    const numberOfItems = beaufortOptionsData.length;
    const numberOfItemsSelected = event.value.length;
    this.filterData().beaufortAllSelected =
      numberOfItems === numberOfItemsSelected;
  }

  resetFilters() {
    this.filterData.set({ ...DEFAULT_FILTER_DATA });
  }
}
